export function normalizeHistory(value) {
  if(!Array.isArray(value)) return [];
  return [...new Set(value.filter(v=>typeof v==='string' && /^[a-z0-9][a-z0-9-]{0,199}$/.test(v)))].slice(0,20);
}
export function remember(history,current) { return normalizeHistory([current,...normalizeHistory(history).filter(h=>h!==current)]); }
const key='mcm-recent-products-v1';
let history=[];
try { history=normalizeHistory(JSON.parse(localStorage.getItem(key))); } catch (_) {}
const current=document.querySelector('[data-mcm-current-product]')?.dataset.mcmCurrentProduct;
if(current) { history=remember(history,current); try{localStorage.setItem(key,JSON.stringify(history));}catch(_){} }
class McmRecentlyViewed extends HTMLElement {
  connectedCallback() {
    this.abort=new AbortController();
    this.observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){this.observer.disconnect();this.load();}},{rootMargin:'400px'});
    this.observer.observe(this);
  }
  async load() {
    const handles=history.filter(h=>h!==this.dataset.current).slice(0,Number(this.dataset.limit)||6);
    const results=new Array(handles.length); let index=0;
    const worker=async()=>{
      while(index<handles.length && !this.abort.signal.aborted) {
        const i=index++;
        try {
          const url=new URL(`${this.dataset.root}products/${handles[i]}`,window.location.origin);
          url.searchParams.set('section_id',this.dataset.section);
          const preview=new URL(window.location.href).searchParams.get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);
          const response=await fetch(url,{signal:this.abort.signal});if(!response.ok)continue;
          const html=new DOMParser().parseFromString(await response.text(),'text/html');
          const card=html.querySelector('template[data-mcm-recent-card]')?.content.querySelector('[data-mcm-recent-item]');
          if(card?.querySelector('product-card'))results[i]=card;
        }catch(error){if(error.name==='AbortError')return;}
      }
    };
    await Promise.all(Array.from({length:Math.min(3,handles.length)},worker));
    if(!this.isConnected)return;
    const cards=results.filter(Boolean);this.querySelector('[data-mcm-recent-grid]').replaceChildren(...cards);
    this.querySelector('[data-mcm-recent-content]').hidden=cards.length===0;
  }
  disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();}
}
if(!customElements.get('mcm-recently-viewed'))customElements.define('mcm-recently-viewed',McmRecentlyViewed);
